module.exports = __webpack_public_path__ + "img/zs16.b3fa80a7.jpg";